export const ROOT_ADMIN = 'RootAdmin'
export const DOMAIN_ADMIN = 'DomainAdmin' // needs domainId to be passed to usePermissions
export const DOMAIN_ADMIN_SOMEWHERE = 'DomainAdminSomewhere' // needs domainId to be passed to usePermissions
export const ROOT_USER = 'RootUser'
export const DOMAINS_DISTRIBUTOR = 'DomainsDistributor'
export const NON_DIRECT_DEALER = 'NonDirectDealer'
export const DOMAIN_NESTING_ENABLED = 'DomainNestingEnabled'
